const Data = [
    {
        id : 1,
        img : "./Static/button.png",
        user: "Single user",
        amount: "$149",
        storage: "500 GB Storage",
        capacity: "1 User Aloowed",
        limit:"Send up to 2GB",
    },
    {
        id : 2,
        img : "./Static/button.png",
        user: "Two users",
        amount: "$129",
        storage: "350 GB Storage",
        capacity: "2 Users Allowed",
        limit:"Send up to 22GB",
    },
    {
        id : 3,
        img : "./Static/button.png",
        user: "Many user",
        amount: "$239",
        storage: "750 GB Storage",
        capacity: "3 Users Allowed",
        limit:"Send up to 50GB",
    }
]
export default Data;